module.exports = __webpack_public_path__ + "img/katarina_bedrooms_1.f9b4a7fb.jpg";